import { useEffect, useState } from 'react'
import styles from '@/styles/contact.module.scss'
import { getContactPage } from '@/service/static-page.api'

export default function Contact() {
  const [html, setHtml] = useState()
  const getPage = async () => {
    const response = await getContactPage()
    setHtml(response.data.contactPage.content)
  }
  useEffect(() => {
    getPage()
  }, [])
  return (
    <div dangerouslySetInnerHTML={{
      __html: html
    }}/>
  )
}
